import {
    HELP_MAIN,
    HELP_MAIN_FAIL,
    HELP_MAIN_SUCCESS,
} from './constants';

// ==============================================
// query
// ==============================================
export const mainHelp = ({params}) => ({
    type: HELP_MAIN,
    payload: {params},
});

export const mainHelpSuccess = (data) => ({
    type: HELP_MAIN_SUCCESS,
    payload: data,
});

export const mainHelpFail = (data) => ({
    type: HELP_MAIN_FAIL,
    payload: data,
});